import React from 'react'
import Banner from './Banner'

export default function LandingPageHeader(props) {
  return <Banner />
}
